var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1979 21.2891C20.0812 21.2779 19.9312 21.2779 19.7979 21.2891C16.8646 21.2002 14.5312 18.8002 14.5312 15.8502C14.5312 12.8335 16.9646 10.3835 19.9979 10.3835C23.0146 10.3835 25.4646 12.8335 25.4646 15.8502C25.4479 18.8002 23.1312 21.2002 20.1979 21.2891Z",
    stroke: "#0B1957",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2341 32.2998C28.2674 35.0164 24.3341 36.6664 20.0008 36.6664C15.6674 36.6664 11.7341 35.0164 8.76746 32.2998C8.90079 30.8498 9.71079 29.4331 11.1608 28.2664C16.2841 24.9664 23.7674 24.9664 28.8408 28.2664C30.2908 29.4331 31.1008 30.8498 31.2341 32.2998Z",
    stroke: "#d44a00",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.6664C28.8366 36.6664 36 29.503 36 20.6664C36 11.8298 28.8366 4.66641 20 4.66641C11.1634 4.66641 4 11.8298 4 20.6664C4 29.503 11.1634 36.6664 20 36.6664Z",
    stroke: "#0B1957",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.e0241eea0c0b801943ebabef29050088.svg";
export { ForwardRef as ReactComponent };